module.exports = __webpack_public_path__ + "FPJ_logo-13ce28d2989bd88d5baf.jpg";